import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/images/logo.svg'
import _imports_1 from '../assets/images/illustration-mockups.svg'


const _hoisted_1 = { class: "huddle-landing-page-with-single-introductory-section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0,
    alt: "Logo"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "illustration w-100",
    src: _imports_1,
    alt: "Mockups Illustration"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", null, "Build The Community Your Fans Will Love", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "content" }, "Huddle re-imagines the way we build communities. You have a voice, but so does your audience. Create connections with your users as you engage in genuine discussion.", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("footer", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "social" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("i", { class: "fa fa-facebook-f" })
    ]),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("i", { class: "fa fa-twitter" })
    ]),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("i", { class: "fa fa-instagram" })
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("section", null, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.Register && _ctx.Register(...args))),
          type: "button"
        }, "Register")
      ]),
      _hoisted_6
    ])
  ]))
}